import type { FormItemUiDefinition } from 'types/formItem.ts';

export interface SelectedRow {
  id: string;
  value: string;
  formItemUiDefinition?: FormItemUiDefinition | null;
  wrapValue?: boolean;
}

export type SelectedRowInput = SelectedRow | string;

export const normalizeSelectedRows = (rows: SelectedRowInput[] = []): SelectedRow[] =>
  rows.map((row) => (typeof row === 'string' ? { id: row, value: '' } : row));

export const EMPTY_DISPLAY_LABEL = '\u00A0';
